import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./ClientsSection.scss";

function ClientsSection(props) {
  const items = [
    {
      name: "X",
      title: "X (fka Twitter)",
      image: "fa-twitter-x.svg",
      width: "25px",
      link: "https://twitter.com/_pdsofficial?lang=en",
    },
    {
      name: "GitHub",
      title: "GitHub",
      image: "fa-github.svg",
      width: "30px",
      link: "https://github.com/edzlabs",
    },
    {
      name: "LinkedIn",
      title: "LinkedIn",
      image: "fa-linkedin.svg",
      width: "30px",
      link: "https://www.linkedin.com/company/personal-digital-spaces/",
    },
  ];
  
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered social-btns-container">
          {items.map((item, index) => (
            <div className="column is-narrow has-text-centered" key={index}>
            <a
              className={`button is-white is-medium is-hovered glow-on-hover ${item.name === 'X' ? 'x-btn' : 'social-btn'}`}
              href={item.link}
            >
              <span className="title is-4 padding-span" style={{ verticalAlign: "baseline" }}>
                {item.title}
              </span>
              <img src={item.image} width={item.width} alt={item.name} style={{ verticalAlign: "-19%" }} />
            </a>
          </div>          
          ))}
        </div>
      </div>
    </Section>
  );
}

export default ClientsSection;
